// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-col{
    width: 15%;
}
.right-col{
    /* width: 85%; */
    /* display: flex; */
    /* display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: var(--space-and-half); */
}

.phases-group {
    width: 100%;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    margin-top: 24px;
}

.phases-group__form__content{
    /* display: inline-flex; */
    width: 100%;
    padding: 24px;
}

.phases-group__form__content-subtitle.baloa-names {
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.phases-group__form__content_form{
    /* display: flex; */
    /* display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: var(--space-and-half); */
    /* margin-top: var(--space); */
    grid-column-start: 1;
    grid-column-end: 9;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 12px;
    margin-top: 11px;
}

.phases-group__form__content_form__grid_content{
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    align-items: center;
}

.phases-group__form__form_select{
    /* width: 30%; */
    /* margin-left: var(--space); */
    grid-column-start: 1;
    grid-column-end: 4;
}

.phases-group__form__form_select .select-field {
    margin: 24px 0 0 0;
}

.phases-group__form__form-match_duration{
    grid-column-start: 5;
    grid-column-end: 7;
}

.phases-group__form__form-match_duration .basic-data__form__content__match_duration .input-field-input{
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.phases-group__form__form-match_duration .basic-data__form__content__match_duration .input-field-label{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
}

.basic-data__form__content__match_duration.input-field {
    margin: 28px 0 0 0;
}

.phases-group__form__form_select .select-field .select-field-label{
    color: var(--primary-dark-color);
    font-weight: var(--font-regular);
    text-transform: unset;
}

.phases-group__form__form_select .select-field .MuiInputBase-root.MuiInput-root.select-field-input {
    background: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.phases-group__form__form_select .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{
    border: none;
}

.phases-group__form__form_select .MuiInput-underline.select-field-input:before{
    border: none;
    transition: none;
}

.phases-group__form__form_select .MuiSelect-select.MuiSelect-select{
    padding: var(--space-half);
}

.statement_phase{
    display: flex;
    margin-top: var(--space);
}

.subscribed_teams {
    /* padding-block-start: 40%; */
    display: flex;
    margin-right: var(--space-half);
}

.info_clasified_by_group{
    margin-left: var(--space-half);
}
.info_best_third{
    margin-left: var(--space-half);
}

.color-text{
    color: var(--basic-gray-color);
}

.margin-text{
    margin-right: var(--space-half);
}

.phases-group .phases-group__form .left-col .subscribed_teams h5 {

    color: var(--mid-gray-color) !important;
    text-align: left;
}

.phases-group .phases-group__form .left-col .subscribed_teams caption
{
    color: var(--basic-gray-color);
    text-align: left;
    width: calc( var(--space-x3) * 2 );
}

.phases-group .phases-group__form .baloa-subtitle-1,
.phases-group .phases-group__form .left-col .subscribed_teams,
.phases-group .right-col .info_number_of_groups {
    margin-bottom: var(--space);

}

.phases-group .phases-group__form .left-col .subscribed_teams,
.phases-group .right-col .info_number_of_groups {
    position: relative;
    top: calc( var(--space) - var(--space-quarter));

}

.phases-group .right-col .info_number_of_groups {
    margin-left: calc( var(--space) + var(--space-half) );

}

.number_of_groups{
    grid-column-start: 8;
    grid-column-end: 11;
}

.number_of_groups__input {
    /* width: 30%; */
    /* margin-left: var(--space); */
}

.number_of_groups_option {
    display: inline-flex;
}

.number_of_groups_option span {
    margin-left: var(--space-quarter);
}

.clasified_by_group{
    grid-column-start: 9;
    grid-column-end: 11;
}

.free{
    grid-column-start: 6;
    grid-column-end: 10;
}

.info_clasified_by_group p,
.number_of_groups_option  {
    /* font-weight: var(--font-bold) !important; */
}

.info_clasified_by_group span,
.number_of_groups_option span {

    color: var(--secondary-color);
    font-weight: var(--font-bold);
}

.best_third{
    grid-column-start: 1;
    grid-column-end: 3;
}

.best_third_team_input{
    grid-column-start: 3;
    grid-column-end: 6;
    margin-top: var(--space);
    /* margin-right: var(--space-x3); */
}

.best_third_team_input .input-field-input {
    max-width: 174px;
}

.input-field .best_third_team__input .input-field-input{
    margin-right: var(--space);
}

.phases-group .right-col .number_of_groups,
.phases-group .right-col .best_third_team,
.phases-group .right-col .clasified_by_group {
    display: flex;
}

.phases-group .right-col .round_trip_matches p:first-child,
.phases-group .right-col .best_third p:first-child {
    font-weight: var(--font-bold) !important;
}

.phases-group .right-col .best_third .MuiFormGroup-root,
.phases-group .right-col .round_trip_matches .MuiFormGroup-root {
    display: inline !important;
}

.phases-group .right-col .best_third_team .best_third_team__input {
    margin-top: var(--space-half);
    /* margin-left: var(--space);
    width:30%; */
    
}

.phases-group .right-col .clasified_by_group .clasified_by_group__input {
    /* margin-top: var(--space-half);
    margin-right: var(--space);
    margin-bottom: 0;
    width: 30%; */
}
.clasified_by_group_info {
    margin-top: var(--space-quarter);
    margin-bottom: var(--space-x2);
    margin-left: var(--space);
}

.phases-group .right-col .round_trip_matches p {
    margin-bottom: var(--space);
}

.phases-group .right-col .round_trip_matches {
    margin-top: var(--space);
}

.phases-group .button{
    margin-bottom: var(--space);
}

.clasified_by_group__input p.input-field__message {
    display: none
}

.phases-group__separator{
    border: 1px solid var(--mid-gray-color);    
    width: 60%;
}
.phases-group__automatic-calendar__title{
    margin-top: var(--space-and-half);
}

.phases-group__automatic-calendar__texto{
    margin-top: var(--space-half);
    margin-bottom: var(--space-x2);
}

.MuiFormGroup-root.phases-group__automatic-calendar__option{
    flex-direction: row;
}

.phases-group__automatic-calendar__subtitle.input-field-label{
    position: relative;
    top: 0;
    left: 0;
    background-color: var(--primary-very-light-color);
    font-weight: var(--font-bold);
    font-family: var(--secondary-font);
    line-height: var(--space);
    font-size: var(--space-half-quarter);
    letter-spacing: 0.004em;
    color: var(--primary-dark-color);
    text-transform: uppercase;
    padding: 0;
}


.MuiFormGroup-root.phases-group__automatic-calendar__option .MuiRadio-colorSecondary.Mui-checked{
    color: var(--new-green-color);
}

.best_third .MuiFormGroup-root .MuiRadio-colorSecondary.Mui-checked{
    color: var(--new-green-color);
}

.best_third .MuiFormGroup-root .MuiFormControlLabel-root .MuiRadio-root{
    color: var(--new-green-color) !important;
}

.phases-group__automatic-calendar__subtitle{
    margin-top: var(--space-and-half);
    margin-bottom: var(--space);
}

.button-content{
    display: flex;
    justify-content: flex-end;
}

.phases-group__item_dragDrop{
    margin-top: var(--space-x2);
}

/* .phases-group__item_dragDrop .baloa-names{
    color: var(--basic-gray-color);
} */

.phases-group__item__ul{
    list-style: none;
    margin-left: -40px;
}

.phases-group__item__row{
    height: 80px;
    display: flex;
    align-items: center;
}

.phases-group__item__row_subtitle{
    display: flex;
    width: 5em;
}

.phases-group__item__row_subtitle.baloa-names{
    color: var(--primary-very-dark-color);
}
.phases-group__item__li{
    background-color: var(--white-color);
    padding: var(--space-half);
    width: 100%;
    margin: var(--space-half);
    border: 1px solid #DDDDDD;
    border-radius: 8px;
}

.phases-group__item__li_text_icon{
    display:flex;
}

.phases-group__item__li_text{
    display: flex;
    align-items: center;
}

.phases-group__item__li_text .baloa-names{
    color: var(--basic-gray-color);
    font-weight: 400;
}

.phases-group__item__li_text img {
    margin-right: var(--space-half);
}

.phases-group__item__li__container{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
}

.phases-group__item_dragDrop_title{
    display: flex;
}

.phases-group__item_dragDrop_title .baloa-names {
    color: var(--primary-very-dark-color)
}

.phases-group__item_dragDrop_title p {
    margin-right: var(--space);
}

.number_of_groups_phases-group_increase-decrease{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-half);
}

.number_of_groups_phases-group_increase-decrease-text.baloa-names{
    color: var(--primary-dark-color);
    margin-right: var(--space-half);
    font-weight: var(--font-regular);
}

.phases-group__form_increase-decrease__value {
    display: flex;
    align-items: center;
    background-color: var( --new-background-color );
    padding: var( --space-quarter );
    border-radius: var( --space-quarter );
    justify-content: space-between;
}

.phases-group__form_increase-decrease__value .btn {
    background-color: var( --new-green-color );
    color: var( --white-color );
    width: var( --space-x2 );
    height: var( --space-x2 );
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var( --space-quarter );
    cursor: pointer;
}

.phases-group__form_increase-decrease__value input {
    border: none;
    background-color: transparent;
    width: var(--space-x3);
    text-align: center;
}

.phases-group__form_increase-decrease__value input:focus {
    outline: none;    
}

.phases-group__form_increase-decrease__value input[type=number]::-webkit-inner-spin-button,
.phases-group__form_increase-decrease__value input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.best_third .MuiFormControlLabel-root span.MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {
    color: var(--basic-gray-color);
    margin-bottom: var(--space-half);
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);/*17px*/
}

.phases-group__item_dragDrop_Subtitle.baloa-names{
    color: var(--basic-gray-color);
    font-weight: 400;
    margin: var(--space) 0;
}

.tournament-phases-config__title_conf_phase .baloa-subtitle-1{
    color: var(--primary-very-dark-color);
}

.tournament-phases-config__title_conf_phase{
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 24px 0 0 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phases-config-set/TounamentPhasesConfigSetComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;;iCAE6B;AACjC;;AAEA;IACI,WAAW;IACX,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB;;iCAE6B;IAC7B,8BAA8B;IAC9B,oBAAoB;IACpB,kBAAkB;IAClB,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;;IAEI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;;IAEI,8BAA8B;IAC9B,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;;;IAGI,2BAA2B;;AAE/B;;AAEA;;IAEI,kBAAkB;IAClB,+CAA+C;;AAEnD;;AAEA;IACI,qDAAqD;;AAEzD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;;;IAGI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,wBAAwB;IACxB,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B;gBACY;;AAEhB;;AAEA;IACI;;;iBAGa;AACjB;AACA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,uCAAuC;IACvC,UAAU;AACd;AACA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iDAAiD;IACjD,6BAA6B;IAC7B,kCAAkC;IAClC,yBAAyB;IACzB,oCAAoC;IACpC,uBAAuB;IACvB,gCAAgC;IAChC,yBAAyB;IACzB,UAAU;AACd;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;GAEG;;AAEH;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,oCAAoC;IACpC,0BAA0B;IAC1B,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,+CAA+C;IAC/C,+BAA+B;IAC/B,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,0CAA0C;IAC1C,2BAA2B;IAC3B,wBAAwB;IACxB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,+BAA+B;IAC/B,mCAAmC,CAAC,OAAO;AAC/C;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yDAAyD;IACzD,sBAAsB;AAC1B","sourcesContent":[".left-col{\n    width: 15%;\n}\n.right-col{\n    /* width: 85%; */\n    /* display: flex; */\n    /* display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: var(--space-and-half); */\n}\n\n.phases-group {\n    width: 100%;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    margin-top: 24px;\n}\n\n.phases-group__form__content{\n    /* display: inline-flex; */\n    width: 100%;\n    padding: 24px;\n}\n\n.phases-group__form__content-subtitle.baloa-names {\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.phases-group__form__content_form{\n    /* display: flex; */\n    /* display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    gap: var(--space-and-half); */\n    /* margin-top: var(--space); */\n    grid-column-start: 1;\n    grid-column-end: 9;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 12px;\n    margin-top: 11px;\n}\n\n.phases-group__form__content_form__grid_content{\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    align-items: center;\n}\n\n.phases-group__form__form_select{\n    /* width: 30%; */\n    /* margin-left: var(--space); */\n    grid-column-start: 1;\n    grid-column-end: 4;\n}\n\n.phases-group__form__form_select .select-field {\n    margin: 24px 0 0 0;\n}\n\n.phases-group__form__form-match_duration{\n    grid-column-start: 5;\n    grid-column-end: 7;\n}\n\n.phases-group__form__form-match_duration .basic-data__form__content__match_duration .input-field-input{\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.phases-group__form__form-match_duration .basic-data__form__content__match_duration .input-field-label{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n}\n\n.basic-data__form__content__match_duration.input-field {\n    margin: 28px 0 0 0;\n}\n\n.phases-group__form__form_select .select-field .select-field-label{\n    color: var(--primary-dark-color);\n    font-weight: var(--font-regular);\n    text-transform: unset;\n}\n\n.phases-group__form__form_select .select-field .MuiInputBase-root.MuiInput-root.select-field-input {\n    background: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.phases-group__form__form_select .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before{\n    border: none;\n}\n\n.phases-group__form__form_select .MuiInput-underline.select-field-input:before{\n    border: none;\n    transition: none;\n}\n\n.phases-group__form__form_select .MuiSelect-select.MuiSelect-select{\n    padding: var(--space-half);\n}\n\n.statement_phase{\n    display: flex;\n    margin-top: var(--space);\n}\n\n.subscribed_teams {\n    /* padding-block-start: 40%; */\n    display: flex;\n    margin-right: var(--space-half);\n}\n\n.info_clasified_by_group{\n    margin-left: var(--space-half);\n}\n.info_best_third{\n    margin-left: var(--space-half);\n}\n\n.color-text{\n    color: var(--basic-gray-color);\n}\n\n.margin-text{\n    margin-right: var(--space-half);\n}\n\n.phases-group .phases-group__form .left-col .subscribed_teams h5 {\n\n    color: var(--mid-gray-color) !important;\n    text-align: left;\n}\n\n.phases-group .phases-group__form .left-col .subscribed_teams caption\n{\n    color: var(--basic-gray-color);\n    text-align: left;\n    width: calc( var(--space-x3) * 2 );\n}\n\n.phases-group .phases-group__form .baloa-subtitle-1,\n.phases-group .phases-group__form .left-col .subscribed_teams,\n.phases-group .right-col .info_number_of_groups {\n    margin-bottom: var(--space);\n\n}\n\n.phases-group .phases-group__form .left-col .subscribed_teams,\n.phases-group .right-col .info_number_of_groups {\n    position: relative;\n    top: calc( var(--space) - var(--space-quarter));\n\n}\n\n.phases-group .right-col .info_number_of_groups {\n    margin-left: calc( var(--space) + var(--space-half) );\n\n}\n\n.number_of_groups{\n    grid-column-start: 8;\n    grid-column-end: 11;\n}\n\n.number_of_groups__input {\n    /* width: 30%; */\n    /* margin-left: var(--space); */\n}\n\n.number_of_groups_option {\n    display: inline-flex;\n}\n\n.number_of_groups_option span {\n    margin-left: var(--space-quarter);\n}\n\n.clasified_by_group{\n    grid-column-start: 9;\n    grid-column-end: 11;\n}\n\n.free{\n    grid-column-start: 6;\n    grid-column-end: 10;\n}\n\n.info_clasified_by_group p,\n.number_of_groups_option  {\n    /* font-weight: var(--font-bold) !important; */\n}\n\n.info_clasified_by_group span,\n.number_of_groups_option span {\n\n    color: var(--secondary-color);\n    font-weight: var(--font-bold);\n}\n\n.best_third{\n    grid-column-start: 1;\n    grid-column-end: 3;\n}\n\n.best_third_team_input{\n    grid-column-start: 3;\n    grid-column-end: 6;\n    margin-top: var(--space);\n    /* margin-right: var(--space-x3); */\n}\n\n.best_third_team_input .input-field-input {\n    max-width: 174px;\n}\n\n.input-field .best_third_team__input .input-field-input{\n    margin-right: var(--space);\n}\n\n.phases-group .right-col .number_of_groups,\n.phases-group .right-col .best_third_team,\n.phases-group .right-col .clasified_by_group {\n    display: flex;\n}\n\n.phases-group .right-col .round_trip_matches p:first-child,\n.phases-group .right-col .best_third p:first-child {\n    font-weight: var(--font-bold) !important;\n}\n\n.phases-group .right-col .best_third .MuiFormGroup-root,\n.phases-group .right-col .round_trip_matches .MuiFormGroup-root {\n    display: inline !important;\n}\n\n.phases-group .right-col .best_third_team .best_third_team__input {\n    margin-top: var(--space-half);\n    /* margin-left: var(--space);\n    width:30%; */\n    \n}\n\n.phases-group .right-col .clasified_by_group .clasified_by_group__input {\n    /* margin-top: var(--space-half);\n    margin-right: var(--space);\n    margin-bottom: 0;\n    width: 30%; */\n}\n.clasified_by_group_info {\n    margin-top: var(--space-quarter);\n    margin-bottom: var(--space-x2);\n    margin-left: var(--space);\n}\n\n.phases-group .right-col .round_trip_matches p {\n    margin-bottom: var(--space);\n}\n\n.phases-group .right-col .round_trip_matches {\n    margin-top: var(--space);\n}\n\n.phases-group .button{\n    margin-bottom: var(--space);\n}\n\n.clasified_by_group__input p.input-field__message {\n    display: none\n}\n\n.phases-group__separator{\n    border: 1px solid var(--mid-gray-color);    \n    width: 60%;\n}\n.phases-group__automatic-calendar__title{\n    margin-top: var(--space-and-half);\n}\n\n.phases-group__automatic-calendar__texto{\n    margin-top: var(--space-half);\n    margin-bottom: var(--space-x2);\n}\n\n.MuiFormGroup-root.phases-group__automatic-calendar__option{\n    flex-direction: row;\n}\n\n.phases-group__automatic-calendar__subtitle.input-field-label{\n    position: relative;\n    top: 0;\n    left: 0;\n    background-color: var(--primary-very-light-color);\n    font-weight: var(--font-bold);\n    font-family: var(--secondary-font);\n    line-height: var(--space);\n    font-size: var(--space-half-quarter);\n    letter-spacing: 0.004em;\n    color: var(--primary-dark-color);\n    text-transform: uppercase;\n    padding: 0;\n}\n\n\n.MuiFormGroup-root.phases-group__automatic-calendar__option .MuiRadio-colorSecondary.Mui-checked{\n    color: var(--new-green-color);\n}\n\n.best_third .MuiFormGroup-root .MuiRadio-colorSecondary.Mui-checked{\n    color: var(--new-green-color);\n}\n\n.best_third .MuiFormGroup-root .MuiFormControlLabel-root .MuiRadio-root{\n    color: var(--new-green-color) !important;\n}\n\n.phases-group__automatic-calendar__subtitle{\n    margin-top: var(--space-and-half);\n    margin-bottom: var(--space);\n}\n\n.button-content{\n    display: flex;\n    justify-content: flex-end;\n}\n\n.phases-group__item_dragDrop{\n    margin-top: var(--space-x2);\n}\n\n/* .phases-group__item_dragDrop .baloa-names{\n    color: var(--basic-gray-color);\n} */\n\n.phases-group__item__ul{\n    list-style: none;\n    margin-left: -40px;\n}\n\n.phases-group__item__row{\n    height: 80px;\n    display: flex;\n    align-items: center;\n}\n\n.phases-group__item__row_subtitle{\n    display: flex;\n    width: 5em;\n}\n\n.phases-group__item__row_subtitle.baloa-names{\n    color: var(--primary-very-dark-color);\n}\n.phases-group__item__li{\n    background-color: var(--white-color);\n    padding: var(--space-half);\n    width: 100%;\n    margin: var(--space-half);\n    border: 1px solid #DDDDDD;\n    border-radius: 8px;\n}\n\n.phases-group__item__li_text_icon{\n    display:flex;\n}\n\n.phases-group__item__li_text{\n    display: flex;\n    align-items: center;\n}\n\n.phases-group__item__li_text .baloa-names{\n    color: var(--basic-gray-color);\n    font-weight: 400;\n}\n\n.phases-group__item__li_text img {\n    margin-right: var(--space-half);\n}\n\n.phases-group__item__li__container{\n    display: flex;\n    justify-content: space-between;\n    flex-direction: row;\n    align-items: center;\n}\n\n.phases-group__item_dragDrop_title{\n    display: flex;\n}\n\n.phases-group__item_dragDrop_title .baloa-names {\n    color: var(--primary-very-dark-color)\n}\n\n.phases-group__item_dragDrop_title p {\n    margin-right: var(--space);\n}\n\n.number_of_groups_phases-group_increase-decrease{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-half);\n}\n\n.number_of_groups_phases-group_increase-decrease-text.baloa-names{\n    color: var(--primary-dark-color);\n    margin-right: var(--space-half);\n    font-weight: var(--font-regular);\n}\n\n.phases-group__form_increase-decrease__value {\n    display: flex;\n    align-items: center;\n    background-color: var( --new-background-color );\n    padding: var( --space-quarter );\n    border-radius: var( --space-quarter );\n    justify-content: space-between;\n}\n\n.phases-group__form_increase-decrease__value .btn {\n    background-color: var( --new-green-color );\n    color: var( --white-color );\n    width: var( --space-x2 );\n    height: var( --space-x2 );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var( --space-quarter );\n    cursor: pointer;\n}\n\n.phases-group__form_increase-decrease__value input {\n    border: none;\n    background-color: transparent;\n    width: var(--space-x3);\n    text-align: center;\n}\n\n.phases-group__form_increase-decrease__value input:focus {\n    outline: none;    \n}\n\n.phases-group__form_increase-decrease__value input[type=number]::-webkit-inner-spin-button,\n.phases-group__form_increase-decrease__value input[type=number]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.best_third .MuiFormControlLabel-root span.MuiTypography-root.MuiFormControlLabel-label.MuiTypography-body1 {\n    color: var(--basic-gray-color);\n    margin-bottom: var(--space-half);\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);/*17px*/\n}\n\n.phases-group__item_dragDrop_Subtitle.baloa-names{\n    color: var(--basic-gray-color);\n    font-weight: 400;\n    margin: var(--space) 0;\n}\n\n.tournament-phases-config__title_conf_phase .baloa-subtitle-1{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-phases-config__title_conf_phase{\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 24px 0 0 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
